import { Add } from "@material-ui/icons";
import { IconButton, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useContext } from "react";
import avtar from "../../assets/images1/avtar.jpg";
import call from "../../assets/images1/call.png";
import emailIcon from "../../assets/images1/email.png";
import web from "../../assets/images1/web.png";
import whatsapp from "../../assets/images1/whatsapp.png";
import rupee from "../../assets/images1/rupee.png";
import placeholder from "../../assets/images1/placeholder.png";
import profile from "../../assets/images1/profile-user.png";
import gallery from "../../assets/images1/gallery.png";
import qrcode from "../../assets/images1/qr-code.png";
import adduser from "../../assets/images1/add-user.png";
import review from "../../assets/images1/review.png";
import DigitalCard from "../../assets/images1/credit-card.png";
import { Settings } from "react-feather";
import noPhoto from "../../assets/images/no-photo.webp";
import "../../assets/main.css";
import "../../assets/slick.css";

import { useNavigate, useParams } from "react-router";
import {
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import PersonalPageContext from "../../context/PersonalPageContext/PersonalPageContaxt";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import OpacityIcon from "@mui/icons-material/Opacity";
import { classes } from "../../data/layouts";
import Switch from "react-js-switch";
import {
  FILE_TYPE,
  LIMIT,
  MOMENT_SETTING,
  QR_THEME_COLORS,
  QR_THEMES,
  qrThemes,
  Style,
  THEME_SELECT,
  TITLES,
  TMPLATE,
  TYPES,
  USER_ROLE,
} from "../../constant";
import {
  Check,
  X,
  Droplet,
  Edit3,
  Plus,
  Upload,
  Trash2,
  RotateCcw,
  Bookmark,
  Share2,
} from "react-feather";
import t15Email from "../../assets/images/theme-15/email.png";
import t15QrCode from "../../assets/images/theme-15/qrCode.png";
import t15Location from "../../assets/images/theme-15/location.png";
import t15Inquiry from "../../assets/images/theme-15/inquiry.png";
import t15Download from "../../assets/images/theme-15/download.png";
import t15SaveContact from "../../assets/images/theme-15/saveContact.png";
import t15Facebook from "../../assets/images/theme-15/Facebook.png";
import t15Instagram from "../../assets/images/theme-15/instagram.png";
import t15Linkedin from "../../assets/images/theme-15/linkedin.png";
import t15Pinterest from "../../assets/images/theme-15/pinterest.png";
import t15Indiamart from "../../assets/images/theme-15/Indiamart.png";
import ProfileComponentContext from "../../context/ProfilecomponentContext/ProfilecomponetContext";
import { SketchPicker } from "react-color";
import {
  Edit_OrgPageList,
  FILE_API,
  Org_PageList_Details,
  PageItemList,
  PagePriviewList,
  getThemeList,
} from "../../api/Organization Api/OrganizationApi";
import { uploadFileToSpaces } from "../../components ByteCard/apis/dashboardAPi/DeshboardApi";
import { toast, Zoom } from "react-toastify";
import PageItemContext from "../../context/PageItemContext/PageItmContext";
import LoaderContext from "../../context/LoaderContext/LoaderContext";
import { TabelAnimation } from "../../Spinner";
import DataNotFound from "../../DataNoteFound/DataNotFound";
import { headerStyle, MuiTabelStyle } from "../../utils/MuiTabelStyle";
import moment from "moment-timezone";
import PreviewPopup from "./preview";
import CallToActionIcon from "@mui/icons-material/CallToAction";
import PersonalPageprevieaw from "./PersonalPageprevieaw";
import { Organization_Detail } from "../../api/SupperAdminOrganizationApi/Organization";
import { TostMessage } from "../../components ByteCard/utils";
import MainOrganizationUpdate from "../../auth/MainOrganizationUpdate";

const PersonalPageItem = (props) => {
  const {
    EditHandle,
    sorting,
    switch_onChange_handle,
    ShowPersonalPage,
    AddPageItem,
  } = props;

  const {
    formvalue,
    setToggle,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setClone,
    pageLimit,
    setPreviewPopup,
    setPreviewArr,
    setCategories,
    setChartData,
    setChartTitle,
    setCalltoActionPopup,
    setLandingName,
    setCalltoActionData,
    personalPageIncentive,
    setPersonalPageIncentive,
    setPersonalPageId,
    setCompanySlugModal,
    companySlugModal,
    setFormDataOrg,
  } = useContext(PersonalPageContext);
  const {
    currentColor,
    setCurrentColor,
    email,
    setEmail,
    fname,
    setFname,
    lname,
    setLname,
    pagetitle,
    setPageTitle,
    orgName,
    setOrgName,
    designation,
    setDesignation,
    address,
    setAddress,
    conuntry,
    setConuntry,
    state,
    setState,
    city,
    setCity,
    logo,
    setLogo,
    userEmail,
    setUserEmail,
    mobile,
    setMobile,
    seoTitle,
    setSeoTitle,
    seoDescription,
    setSeoDescription,
    seoKey,
    setSeoKey,
    setIsAddHandle,
    seteditIndex,
    setPassword,
    setConfirmPassword,
    setData,
    setCheck,
    setType,
    setActionQpiId,
    setIsDialog,
    setIsFource,
    setIsBranchLabel,
    setIsShowBranch,
    setIsLabel,
    isDialog,
    isFource,
    isLabel,
    userPhoto,
    setUserPhoto,
    filter,
    setFilter,
    templateId,
    setTemplateId,
    pageThemeConfigColors,
    setPageThemeConfigColors,
    borderColor,
    setBorderColor,
  } = useContext(ProfileComponentContext);
  const { setPageUuid } = useContext(PageItemContext);

  const { loaderShow, setLoaderShow, tabelAnimation } =
    useContext(LoaderContext);

  const [color, setColor] = useState(false);
  const [theme, setTheme] = useState(false);
  const [border, setBorder] = useState(false);
  const [backGround, setBackGround] = useState(false);
  const [themeFont, setThemeFont] = useState(false);
  const [themePassUuuid, setThemePassUuid] = useState("");
  const [fontTheme, setFontColor] = useState("#fff");
  const [backgoundTheme, setBackgoundTheme] = useState("");
  const [pageId, setPageId] = useState("");
  const [startDate, setStartData] = useState("");
  const [endDate, setEndData] = useState("");
  const [backgroundImg, setBackgroundImg] = useState("");
  const [isUploadingBg, setIsUploadingBg] = useState(false);
  const [isTheme15Backstructure, setIsTheme15Backstructure] = useState(true);

  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper",
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();
  const history = useNavigate();
  let { hwId } = useParams();

  /**
   *  empty feild function
   */

  const emptyFeild = () => {
    setPageThemeConfigColors({});
    setMobile("");
    setUserEmail("");
    setEmail("");
    setFname("");
    setLname("");
    setPageTitle("");
    setOrgName("");
    setDesignation("");
    setAddress("");
    setConuntry("");
    setTemplateId("");
    setState("");
    setCity("");
    setLogo("");
    setCurrentColor("");
    setBorderColor("");
    setFontColor("");
    setSeoDescription("");
    setSeoKey("");
    setSeoTitle("");
    setPassword("");
    setConfirmPassword("");
    setData([]);
    setIsDialog(false);
    setIsFource(false);
    setIsLabel("");
    setIsBranchLabel("");
    setIsShowBranch("");
    setUserPhoto("");
    setThemeFont(false);
    setTheme(false);
    setBorder(false);
    setBackGround(false);
    setBackgroundImg("");
    setIsUploadingBg(false);
    setIsTheme15Backstructure(true);
  };

  /**
   * Add User
   */

  const AddProfile = () => {
    if (pageLimit === record) {
      toast.error("You Have Reached Maximum Limit ", {
        autoClose: 1000,
        transition: Zoom,
      });
    } else {
      setClone(true);
      setToggle(false);
      setIsAddHandle(true);
      setCheck(true);
      seteditIndex(-1);
      emptyFeild();
      history(`/${hwId}/ProfileComponent/${layout}`);
    }
  };

  const getThemeListData = async () => {
    try {
      let paramObj = {
        isThemeSellerAccess: true,
        showAll: true,
        sortBy: "label",
        sortOrder: "ASC",
      };
      const { data } = await getThemeList(paramObj);
      if (data.status === 200) {
        return data.payload.data;
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * Clone User
   */

  const cloneUser = async (pageUuid, orgId) => {
    if (pageLimit === record) {
      toast.error("You Have Reached Maximum Limit ", {
        autoClose: 1000,
        transition: Zoom,
      });
    } else {
      emptyFeild();
      setLoaderShow(!loaderShow);
      try {
        const { data } = await Org_PageList_Details(pageUuid);
        if (data.status === 200) {
          const theme = await getThemeListData();
          setClone(false);
          setToggle(false);
          setIsAddHandle(true);
          setCheck(true);
          setPageUuid(pageUuid);
          const payload = data.payload.data;
          setEmail(payload.email);
          setFname(payload.fname);
          setLname(payload.lname);
          setPageTitle(payload.pageTitle);
          setOrgName(payload.orgDetail.orgName);
          setDesignation(payload.designation);
          setAddress(payload.address);
          setConuntry(payload.country);
          setState(payload.state);
          setCity(payload.city);
          setLogo(payload.orgLogo);
          setUserPhoto(payload.userPhoto);
          setSeoTitle(payload.seoTitle);
          setSeoDescription(payload.scoDesc);
          setSeoKey(payload.scoKeyword);
          setData(
            theme
              .filter((elem) => payload.templateId === elem.code)
              .map((item) => ({
                value: item.code,
                label: item.templateName,
              })),
          );
          setIsDialog(payload.config.isDialog);
          setIsFource(payload.config.isFource);
          setIsLabel(payload.config.isLabel);
          setTheme(payload.pageThemeConfig.themeColor);
          setColor(payload.pageThemeConfig.fontColor);
          setBorderColor(payload?.pageThemeConfig?.borderColor || "");
          setLoaderShow(false);
          history(`/${hwId}/ProfileComponent/${layout}`);
        } else {
        }
      } catch (error) {
        toast.error(error.response, {
          autoClose: 1000,
          transition: Zoom,
        });
        setLoaderShow(false);
      }
    }
  };

  /**
   * Theme color and font color get details
   */

  const OpenThemePopup = async (pageUuid, orgId) => {
    setThemePassUuid(pageUuid);
    emptyFeild();
    setLoaderShow(!loaderShow);
    try {
      const { data } = await Org_PageList_Details(pageUuid);
      if (data.status === 200) {
        const payload = data.payload.data;
        const theme = await getThemeListData();
        setEmail(payload.email);
        setFname(payload.fname);
        setLname(payload.lname);
        setPageTitle(payload.pageTitle);
        setOrgName(payload.orgDetail.orgName);
        setDesignation(payload.designation);
        setAddress(payload.address);
        setConuntry(payload.country);
        setState(payload.state);
        setCity(payload.city);
        setLogo(payload.orgLogo);
        setSeoTitle(payload.seoTitle);
        setSeoDescription(payload.scoDesc);
        setSeoKey(payload.scoKeyword);
        setTemplateId(payload.templateId);

        setUserEmail(payload.userEmail);
        setMobile(payload.mobile);
        setUserPhoto(payload.userPhoto);
        setIsDialog(payload.config ? payload.config.isDialog : false);
        setIsFource(payload.config ? payload.config.isFource : false);
        setIsLabel(payload.config ? payload.config.isLabel : "");
        const themeNumber = QR_THEMES[`${payload.templateId}`];
        const themeDefColor = QR_THEME_COLORS[themeNumber];
        let themeColor = payload.pageThemeConfig?.[themeNumber] || {
          ...themeDefColor,
        };
        pageThemeConfig(themeColor);
        setPageThemeConfigColors(payload.pageThemeConfig || {});
        setData(
          theme
            .filter((elem) => payload.templateId === elem.code)
            .map((item) => ({
              value: item.code,
              label: item.templateName,
            })),
        );
        setLoaderShow(false);
        setColor(true);
      } else {
      }
    } catch (error) {
      toast.error(error.response, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  /**
   * Object return data to set data in state function call
   */

  function pageThemeConfig(data) {
    setCurrentColor(data ? data.themeColor : "");
    setBorderColor(data ? data?.borderColor : "");
    setFontColor(data ? data.fontColor : "");
    setBackgoundTheme(data ? data?.backgroundColor : "");
    setBackgroundImg(data ? data?.backgroundImg || "" : "");
    setIsTheme15Backstructure(
      data?.backstructure !== undefined ? Boolean(data?.backstructure) : true
    );
  }

  /**
   * Theme color and font color submit
   */

  const handleBackgroundUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const selectedFile = files[0];
    if (selectedFile.size > 5 * 1024 * 1024) {
      toast.error("Image size must be less than 5 MB", {
        autoClose: 1000,
        transition: Zoom,
      });
      return;
    }
    const uniqueName = `${Date.now()}-${selectedFile.name}`;
    const uploadPayload = {
      type: FILE_TYPE.PAGE_ITEM,
      file: uniqueName,
      fileType: selectedFile.type,
    };
    try {
      setIsUploadingBg(true);
      const { data } = await FILE_API(uploadPayload);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          toast.error("Failed to get upload URL", {
            autoClose: 1000,
            transition: Zoom,
          });
          setIsUploadingBg(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, selectedFile);
        const fullUrl = data.payload.imageUrl?.startsWith("http")
          ? data.payload.imageUrl
          : `${data.payload.baseUrl || ""}${data.payload.imageUrl}`;
        setBackgroundImg(fullUrl);
        toast.success("Background image uploaded successfully", {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to upload image",
        {
          autoClose: 1000,
          transition: Zoom,
        },
      );
    } finally {
      setIsUploadingBg(false);
      e.target.value = "";
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoaderShow(!loaderShow);
    let logoUrl =
      logo && logo?.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
    let userLogoUrl =
      userPhoto &&
      userPhoto?.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
    let pageColor = { ...pageThemeConfigColors };
    const themeNumber = QR_THEMES[templateId];

    if (borderColor && templateId === qrThemes.theme8) {
      pageColor[themeNumber] = {
        ...pageColor[themeNumber],
        themeColor: currentColor,
        fontColor: fontTheme || "#000000",
        borderColor: borderColor,
      };
    } else if (templateId === qrThemes.theme10) {
      pageColor[themeNumber] = {
        ...pageColor[themeNumber],
        themeColor: currentColor,
        fontColor: fontTheme || "#FFFFFF",
        backgroundColor: backgoundTheme || "#97bcc6",
      };
    } else if (templateId === qrThemes.theme15) {
      pageColor[themeNumber] = {
        ...pageColor[themeNumber],
        themeColor: currentColor,
        fontColor: fontTheme || "#171719",
        backgroundColor: backgoundTheme || "#d5e2fc",
        backstructure: isTheme15Backstructure,
      };
    } else if (templateId === qrThemes.theme14) {
      pageColor[themeNumber] = {
        ...pageColor[themeNumber],
        themeColor: currentColor,
        fontColor: fontTheme || "#f4f1ea",
        backgroundImg: backgroundImg || "",
      };
    } else {
      pageColor[themeNumber] = {
        ...pageColor[themeNumber],
        themeColor: currentColor,
        fontColor: fontTheme || "#000000",
      };
    }
    let formData = {
      seoTitle: seoTitle,
      seoKeyword: seoKey,
      seoDesc: seoDescription,
      mobile,
      userEmail,
      email,
      fname,
      lname,
      pageTitle: pagetitle,
      orgName,
      designation,
      address,
      country: conuntry,
      state,
      city,
      templateId: templateId,
      orgLogo: logoUrl,
      userPhoto: userLogoUrl,
      pageThemeConfig: pageColor,
      config: {
        isDialog,
        isFource,
        isLabel,
      },
      type: TYPES.LANDING_PAGE,
    };

    try {
      const { data } = await Edit_OrgPageList(formData, themePassUuuid);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
        });
        setColor(false);
        setLoaderShow(false);
        emptyFeild();
      } else {
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  /**
   * Open Popup to close popup to empty feild
   */

  const close = () => {
    emptyFeild();
    setColor(!color);
  };

  /**
   * Reset theme to default colors
   */
  const handleResetTheme = () => {
    const themeNumber = QR_THEMES[`${templateId}`];
    const defColors = QR_THEME_COLORS[themeNumber];
    if (defColors) {
      setCurrentColor(defColors.themeColor || "");
      setFontColor(defColors.fontColor || "#000000");
    }
    if (templateId === qrThemes.theme8) {
      setBorderColor("");
    } else if (templateId === qrThemes.theme10) {
      setBackgoundTheme("#97bcc6");
    } else if (templateId === qrThemes.theme15) {
      setBackgoundTheme("#d5e2fc");
      setIsTheme15Backstructure(true);
    } else if (templateId === qrThemes.theme14) {
      setBackgroundImg("");
    }
  };

  /**
   * Home pagr Theme Color and Font Color Select
   */

  const handleOnChange = (color) => {
    setCurrentColor(color.hex);
  };
  const handleOnChangeBorder = (color) => {
    setBorderColor(color.hex);
  };
  const handleOnChangeFont = (color) => {
    setFontColor(color.hex);
  };
  const handleOnChangeBackgound = (color) => {
    setBackgoundTheme(color.hex);
  };

  const SelectTheme = () => {
    if (theme === false) {
      setTheme(true);
      setBorder(false);
      setBackGround(false);
      setThemeFont(false);
    } else if (theme === true) {
      setTheme(false);
    }
  };
  const SelectThemeBorder = () => {
    if (border === false) {
      setBorder(true);
      setTheme(false);
      setBackGround(false);
      setThemeFont(false);
    } else if (theme === true) {
      setBorder(false);
    }
  };
  const SelectThemeBackground = () => {
    if (backGround === false) {
      setBackGround(true);
      setBorder(false);
      setTheme(false);
      setThemeFont(false);
    } else if (theme === true) {
      setBorder(false);
    }
  };
  const SelectFontTheme = () => {
    if (themeFont === false) {
      setThemeFont(true);
      setTheme(false);
      setBackGround(false);
      setBorder(false);
    } else if (themeFont === true) {
      setThemeFont(false);
    }
  };

  const appStyle = {
    background: { backgroundColor: currentColor },
    color: { color: fontTheme },
  };

  const handlePreview = async (pageId, start, end, value, pageTitle) => {
    localStorage.setItem("title", pageTitle);
    setLoaderShow(!loaderShow);
    setChartTitle(pageTitle);
    setPageId(pageId);
    setChartData([]);
    setCategories([]);

    try {
      let paramObj = {
        pageId,
        sortOrder: "ASC",
      };
      if (start !== undefined || end !== undefined) {
        if (start !== undefined) {
          if (start) {
            paramObj["startDate"] = start;
            paramObj["showAll"] = true;
          }
        }
        if (end !== undefined) {
          if (end) {
            paramObj["endDate"] = end;
            paramObj["showAll"] = true;
          }
        }
      }
      if (value === "chart") {
        paramObj["sortOrder"] = "ASC";
        paramObj["startDate"] = startDate;
        paramObj["endDate"] = endDate;
        if (startDate && endDate) {
          paramObj["showAll"] = true;
        }
      } else if (value === "list") {
        paramObj["sortOrder"] = "DESC";
        paramObj["startDate"] = startDate;
        paramObj["endDate"] = endDate;
        if (startDate && endDate) {
          paramObj["showAll"] = true;
        }
      }
      const { data } = await PagePriviewList(paramObj);

      if (data.status === 200) {
        setPreviewPopup(true);
        setPreviewArr(data.payload.data);
        for (let i of data.payload.data) {
          setCategories((oldArray) => [
            ...oldArray,
            moment.utc(i.createdAt).format(MOMENT_SETTING.FORMATE),
          ]);
          setChartData((oldArray) => [...oldArray, i.views]);
        }
        setLoaderShow(false);
        if (!data.payload.data.length) {
          setChartData([]);
          setCategories([]);
        }
      } else {
        setLoaderShow(false);
      }
    } catch (error) {
      setLoaderShow(false);
    }
  };

  const nfcGet = async (pageUuid) => {
    setLoaderShow(true);
    let search = {
      isCallToAction: true,
    };
    try {
      const { data } = await PageItemList(pageUuid, search);
      if (data.status === 200) {
        setCalltoActionData(data.payload.data);
        setLoaderShow(false);
      } else {
        setLoaderShow(false);
      }
    } catch (error) {
      setLoaderShow(false);
    }
  };

  const showCallToAcionPopup = (pageUuid, pageTitle, type, actionQpiId) => {
    setCalltoActionPopup(true);
    setLandingName(pageTitle);
    nfcGet(pageUuid);
    setPageUuid(pageUuid);
    setType(type);
    setActionQpiId(actionQpiId);
  };

  /**
   * Table coloums array
   */
  const defaultColumns =
    +localStorage.getItem("isBrokerAllowed") !== 0
      ? [
          {
            flex: 0.01,
            minWidth: 100,
            field: "sNo",
            headerName: "S.No.",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "edit",
            headerName: <div>Page (Step-1)</div>,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Edit">
                <IconButton
                  aria-label="edit"
                  style={{ color: "green" }}
                  onClick={() =>
                    EditHandle(params.row.pageUuid, params.row.orgId)
                  }
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
            ),
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "item",
            headerName: <div>Item (Step-2)</div>,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Item">
                <IconButton
                  aria-label="item"
                  onClick={() =>
                    AddPageItem(
                      params.row.pageUuid,
                      params.row.pageTitle,
                      pageLimit,
                    )
                  }
                >
                  <Plus style={{ color: "green" }} />
                </IconButton>
              </Tooltip>
            ),
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "default",
            headerName: <div>Action (Step-3)</div>,
            renderCell: (params) => {
              return (
                <>
                  <Tooltip title="call to action">
                    <IconButton
                      aria-label="detail"
                      // style={{ color: "green" }}
                      onClick={() =>
                        showCallToAcionPopup(
                          params.row.pageUuid,
                          params.row.pageTitle,
                          params.row.type,
                          params.row.actionQpiId,
                        )
                      }
                    >
                      <CallToActionIcon />
                    </IconButton>
                  </Tooltip>
                </>
              );
            },
          },
          {
            field: "home",
            headerName: "View",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="View">
                <IconButton aria-label="view" style={{ color: "yellowgreen" }}>
                  <a
                    href={`https://${localStorage.getItem(
                      "qrDomain",
                    )}.${localStorage.getItem("domain")}/${hwId}${
                      params.row.roleId !== USER_ROLE.PAGE_ADMIN
                        ? `?p=${params.row.pageId}`
                        : ""
                    }`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "flex" }}
                  >
                    <VisibilityIcon />
                  </a>
                </IconButton>
              </Tooltip>
            ),
          },
          {
            field: "qr",
            headerName: "QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="QR">
                <IconButton aria-label="qr">
                  <a
                    href={params.row.qrCode}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "flex" }}
                  >
                    <QrCodeScannerIcon />
                  </a>
                </IconButton>
              </Tooltip>
            ),
          },
          {
            field: "menuQrCode",
            headerName: "Menu QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.menuQrCode ? (
                <Tooltip title="QR">
                  <IconButton aria-label="qr">
                    <a
                      href={params.row.menuQrCode}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "flex" }}
                    >
                      <QrCodeScannerIcon />
                    </a>
                  </IconButton>
                </Tooltip>
              ) : (
                "--"
              ),
          },
          {
            field: "menuHomeQr",
            headerName: "Home QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.menuHomeQr ? (
                <Tooltip title="QR">
                  <IconButton aria-label="qr">
                    <a
                      href={params.row.menuHomeQr}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "flex" }}
                    >
                      <QrCodeScannerIcon />
                    </a>
                  </IconButton>
                </Tooltip>
              ) : (
                "--"
              ),
          },
          {
            minWidth: 100,
            flex: 0.1,
            field: "orgLogo",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerName: "Logo",
            renderCell: (params) =>
              params.row.orgLogo ? (
                <img
                  src={params.row.orgLogo}
                  alt=""
                  style={{ width: "70px" }}
                />
              ) : (
                <img src={noPhoto} alt="" style={{ width: "70px" }} />
              ),
          },
          {
            flex: 0.1,
            minWidth: 200,
            field: "pageTitle",
            headerName: "Page Title",
            renderCell: (params) =>
              params.row.pageTitle ? params.row.pageTitle : "-",
          },
          {
            flex: 0.1,
            minWidth: 140,
            field: "mobile",
            headerName: "Mobile",
            renderCell: (params) =>
              params.row.mobile ? params.row.mobile : "-",
          },
          {
            flex: 0.1,
            minWidth: 100,
            field: "views",
            headerName: "View Count",
            renderCell: (params) =>
              params.row.views ? (
                <p
                  style={{ color: "#7366ff", cursor: "pointer" }}
                  onClick={() =>
                    handlePreview(
                      params.row.pageId,
                      null,
                      null,
                      null,
                      params.row.pageTitle,
                    )
                  }
                >
                  {params.row.views}
                </p>
              ) : (
                "0"
              ),
          },
          {
            flex: 0.1,
            minWidth: 100,
            field: "totalIncentive",
            headerName: "Incentive",
            renderCell: (params) =>
              params.row.totalProjectIncentive ? (
                <p
                  style={{ color: "#7366ff", cursor: "pointer" }}
                  onClick={() => {
                    setPersonalPageIncentive(true);
                    setPersonalPageId({ pageId: params.row.pageId });
                  }}
                >
                  {params.row.totalProjectIncentive}
                </p>
              ) : (
                "-"
              ),
          },
          {
            field: "isActive",
            headerName: "Status",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Switch
                value={params.row.isActive ? true : false}
                onChange={() =>
                  switch_onChange_handle(
                    params.row.pageUuid,
                    params.row.isActive,
                  )
                }
              />
            ),
          },

          {
            field: "view",
            headerName: "Detail",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Detail">
                <IconButton
                  aria-label="detail"
                  // style={{ color: "green" }}
                  onClick={() => ShowPersonalPage(params.row.pageUuid)}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            ),
          },

          {
            field: "copy",
            headerName: "Copy",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              USER_ROLE.PAGE_USER === +localStorage.getItem("roleId") ? (
                "--"
              ) : (
                <Tooltip title="Copy">
                  <IconButton
                    aria-label="copy"
                    style={{ color: "pink" }}
                    onClick={() =>
                      cloneUser(params.row.pageUuid, params.row.orgId)
                    }
                  >
                    <FileCopyIcon />
                  </IconButton>
                </Tooltip>
              ),
          },

          {
            field: "theme",
            headerName: "Theme",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.templateId === TMPLATE.old ||
              params.row.templateId === TMPLATE.theme8 ||
              params.row.templateId === TMPLATE.theme13 ||
              params.row.templateId === TMPLATE.theme11 ||
              params.row.templateId === TMPLATE.theme9 ||
              params.row.templateId === TMPLATE.theme10 ||
              params.row.templateId === TMPLATE.theme14 ||
              params.row.templateId === TMPLATE.theme15 ? (
                <Tooltip title="Theme">
                  <IconButton
                    aria-label="theme"
                    onClick={() =>
                      OpenThemePopup(params.row.pageUuid, params.row.orgId)
                    }
                    style={
                      params.row.templateId === TMPLATE.new
                        ? { color: "#c8d3b2" }
                        : { color: "yellowgreen" }
                    }
                    disabled={params.row.templateId === TMPLATE.new}
                  >
                    <OpacityIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                "-"
              ),
          },
          // {
          //   field: "delete",
          //   headerName: "Delete",
          //   sortable: false,
          //   filterable: false,
          //   disableColumnMenu: true,
          //   renderCell: (params) => (
          //     // params.row.roleId === USER_ROLE.PAGE_ADMIN ? (
          //     //   "--"
          //     //   ) :
          //     // USER_ROLE.PAGE_USER === +localStorage.getItem("roleId") ? (
          //     //   "--"
          //     // ) :
          //     <Tooltip title="Delete">
          //       <IconButton
          //         aria-label="delete"
          //         style={
          //           params.row.roleId === USER_ROLE.PAGE_ADMIN ||
          //           USER_ROLE.PAGE_USER === +localStorage.getItem("roleId")
          //             ? { color: DELETE.color_disabled }
          //             : { color: DELETE.color }
          //         }
          //         onClick={() => DeleteHandle(params.row.pageUuid)}
          //         disabled={
          //           params.row.roleId === USER_ROLE.PAGE_ADMIN ||
          //           USER_ROLE.PAGE_USER === +localStorage.getItem("roleId")
          //         }
          //       >
          //         <DeleteIcon />
          //       </IconButton>
          //     </Tooltip>
          //   ),
          // },
          {
            flex: 0.1,
            minWidth: 150,
            field: "createdAt",
            headerName: "Created Date",
            renderCell: (params) =>
              params.row.createdAt
                ? moment
                    .utc(params.row.createdAt)
                    .format(MOMENT_SETTING.FORMATE)
                : "-",
          },
        ]
      : [
          {
            flex: 0.01,
            minWidth: 100,
            field: "sNo",
            headerName: "S.No.",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "edit",
            headerName: <div>Page (Step-1)</div>,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Edit">
                <IconButton
                  aria-label="edit"
                  style={{ color: "green" }}
                  onClick={() =>
                    EditHandle(params.row.pageUuid, params.row.orgId)
                  }
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
            ),
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "item",
            headerName: <div>Item (Step-2)</div>,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Item">
                <IconButton
                  aria-label="item"
                  onClick={() =>
                    AddPageItem(
                      params.row.pageUuid,
                      params.row.pageTitle,
                      pageLimit,
                    )
                  }
                >
                  <Plus style={{ color: "green" }} />
                </IconButton>
              </Tooltip>
            ),
          },
          {
            flex: 0.01,
            minWidth: 130,
            field: "default",
            headerName: <div>Action (Step-3)</div>,
            renderCell: (params) => {
              return (
                <>
                  <Tooltip title="call to action">
                    <IconButton
                      aria-label="detail"
                      // style={{ color: "green" }}
                      onClick={() =>
                        showCallToAcionPopup(
                          params.row.pageUuid,
                          params.row.pageTitle,
                          params.row.type,
                          params.row.actionQpiId,
                        )
                      }
                    >
                      <CallToActionIcon />
                    </IconButton>
                  </Tooltip>
                </>
              );
            },
          },
          {
            field: "home",
            headerName: "View",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="View">
                <IconButton aria-label="view" style={{ color: "yellowgreen" }}>
                  <a
                    href={`https://${localStorage.getItem(
                      "qrDomain",
                    )}.${localStorage.getItem("domain")}/${hwId}${
                      params.row.roleId !== USER_ROLE.PAGE_ADMIN
                        ? `?p=${params.row.pageId}`
                        : ""
                    }`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "flex" }}
                  >
                    <VisibilityIcon />
                  </a>
                </IconButton>
              </Tooltip>
            ),
          },
          {
            field: "qr",
            headerName: "QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="QR">
                <IconButton aria-label="qr">
                  <a
                    href={params.row.qrCode}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: "flex" }}
                  >
                    <QrCodeScannerIcon />
                  </a>
                </IconButton>
              </Tooltip>
            ),
          },
          {
            field: "menuQrCode",
            headerName: "Menu QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.menuQrCode ? (
                <Tooltip title="QR">
                  <IconButton aria-label="qr">
                    <a
                      href={params.row.menuQrCode}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "flex" }}
                    >
                      <QrCodeScannerIcon />
                    </a>
                  </IconButton>
                </Tooltip>
              ) : (
                "--"
              ),
          },
          {
            field: "menuHomeQr",
            headerName: "Home QR",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.menuHomeQr ? (
                <Tooltip title="QR">
                  <IconButton aria-label="qr">
                    <a
                      href={params.row.menuHomeQr}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "flex" }}
                    >
                      <QrCodeScannerIcon />
                    </a>
                  </IconButton>
                </Tooltip>
              ) : (
                "--"
              ),
          },
          {
            minWidth: 100,
            flex: 0.1,
            field: "orgLogo",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerName: "Logo",
            renderCell: (params) =>
              params.row.orgLogo ? (
                <img
                  src={params.row.orgLogo}
                  alt=""
                  style={{ width: "70px" }}
                />
              ) : (
                <img src={noPhoto} alt="" style={{ width: "70px" }} />
              ),
          },
          {
            flex: 0.1,
            minWidth: 200,
            field: "pageTitle",
            headerName: "Page Title",
            renderCell: (params) =>
              params.row.pageTitle ? params.row.pageTitle : "-",
          },
          {
            flex: 0.1,
            minWidth: 140,
            field: "mobile",
            headerName: "Mobile",
            renderCell: (params) =>
              params.row.mobile ? params.row.mobile : "-",
          },
          {
            flex: 0.1,
            minWidth: 100,
            field: "views",
            headerName: "View Count",
            renderCell: (params) =>
              params.row.views ? (
                <p
                  style={{ color: "#7366ff", cursor: "pointer" }}
                  onClick={() =>
                    handlePreview(
                      params.row.pageId,
                      null,
                      null,
                      null,
                      params.row.pageTitle,
                    )
                  }
                >
                  {params.row.views}
                </p>
              ) : (
                "0"
              ),
          },
          {
            field: "isActive",
            headerName: "Status",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Switch
                value={params.row.isActive ? true : false}
                onChange={() =>
                  switch_onChange_handle(
                    params.row.pageUuid,
                    params.row.isActive,
                  )
                }
              />
            ),
          },

          {
            field: "view",
            headerName: "Detail",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Tooltip title="Detail">
                <IconButton
                  aria-label="detail"
                  // style={{ color: "green" }}
                  onClick={() => ShowPersonalPage(params.row.pageUuid)}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            ),
          },

          {
            field: "copy",
            headerName: "Copy",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              USER_ROLE.PAGE_USER === +localStorage.getItem("roleId") ? (
                "--"
              ) : (
                <Tooltip title="Copy">
                  <IconButton
                    aria-label="copy"
                    style={{ color: "pink" }}
                    onClick={() =>
                      cloneUser(params.row.pageUuid, params.row.orgId)
                    }
                  >
                    <FileCopyIcon />
                  </IconButton>
                </Tooltip>
              ),
          },

          {
            field: "theme",
            headerName: "Theme",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) =>
              params.row.templateId === TMPLATE.old ||
              params.row.templateId === TMPLATE.theme8 ||
              params.row.templateId === TMPLATE.theme13 ||
              params.row.templateId === TMPLATE.theme11 ||
              params.row.templateId === TMPLATE.theme9 ||
              params.row.templateId === TMPLATE.theme10 ||
              params.row.templateId === TMPLATE.theme14 ||
              params.row.templateId === TMPLATE.theme15 ? (
                <Tooltip title="Theme">
                  <IconButton
                    aria-label="theme"
                    onClick={() =>
                      OpenThemePopup(params.row.pageUuid, params.row.orgId)
                    }
                    style={
                      params.row.templateId === TMPLATE.new
                        ? { color: "#c8d3b2" }
                        : { color: "yellowgreen" }
                    }
                    disabled={params.row.templateId === TMPLATE.new}
                  >
                    <OpacityIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                "-"
              ),
          },
          {
            flex: 0.1,
            minWidth: 150,
            field: "createdAt",
            headerName: "Created Date",
            renderCell: (params) =>
              params.row.createdAt
                ? moment
                    .utc(params.row.createdAt)
                    .format(MOMENT_SETTING.FORMATE)
                : "-",
          },
        ];
  const getCompanySlugUrl = async () => {
    try {
      let formData = {
        orgId: localStorage.getItem("orgId"),
      };
      const { data } = await Organization_Detail(formData);
      setFormDataOrg((prev) => {
        return {
          ...prev,
          slugUrl: data.payload.data.slugUrl,
          orgName: data.payload.data.orgName,
        };
      });
      setCompanySlugModal(true);
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  return (
    <>
      {personalPageIncentive && <PersonalPageprevieaw />}

      {/** Landing Page Table */}
      <Container fluid={true}>
        <Row>
          {+localStorage.getItem("roleId") === USER_ROLE.PAGE_ADMIN && (
            <div
              style={{
                paddingLeft: "26px",
                paddingBottom: "12px",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <p style={{ fontSize: "16px", paddingRight: "40px" }}>
                {LIMIT.TOTAL_PAGE_LIMIT} : {pageLimit}
              </p>
              <p style={{ fontSize: "16px" }}>
                {LIMIT.AVAILABLE_PAGE_LIMIT} : {pageLimit - record}
              </p>
              {/* <Tooltip title="Edit Company Slug Url" className="px-2">
                <IconButton
                  edge="start"
                  color="inherit"
                  style={{ marginLeft: "5px" }}
                  onClick={() => getCompanySlugUrl()}
                >
                  <Settings />
                </IconButton>
              </Tooltip> */}
            </div>
          )}

          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <h3 style={headerStyle}>{TITLES.LANDING_PAGE}</h3>
                {USER_ROLE.PAGE_USER ===
                +localStorage.getItem("roleId") ? null : pageLimit ===
                  record ? (
                  <div
                    aria-label="add"
                    onClick={() => AddProfile()}
                    className="btn btn-primary"
                    style={Style}
                  >
                    <Add />
                  </div>
                ) : (
                  <div
                    aria-label="add"
                    onClick={() => AddProfile()}
                    className="btn btn-primary"
                    style={Style}
                  >
                    <Add />
                  </div>
                )}
              </CardHeader>
              <Row>
                <Col md={"2 my-3 mx-2"}>
                  <Input
                    placeholder="Search ..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />
                </Col>
              </Row>
              {tabelAnimation === true ? (
                <TabelAnimation />
              ) : formvalue.length ? (
                <DataGrid
                  autoHeight
                  sx={MuiTabelStyle}
                  pagination
                  rows={formvalue}
                  getRowId={(row) => row.pageUuid}
                  columns={defaultColumns}
                  rowsPerPageOptions={[7, 10, 25, 50]}
                  rowCount={record}
                  pageSize={pageSize}
                  page={page - 1}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                  paginationMode="server"
                  disableSelectionOnClick
                  checkboxSelection={false}
                  sortingMode="server"
                  onSortModelChange={sorting}
                />
              ) : (
                <DataNotFound />
              )}
            </Card>
          </Col>
        </Row>
      </Container>
      {/* /** Home Page Theme Select and Font Color Select */}
      <Modal size="lg" isOpen={color}>
        {/* <LoaderResponse /> */}
        <ModalHeader>
          <span>Select Your Home Page Theme</span>
        </ModalHeader>
        <ModalBody>
          <ModalHeader
            style={{ display: "block", justifyContent: "space-between" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  style={{
                    padding: "1rem",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <div
                    aria-label="add"
                    className="btn"
                    onClick={() => SelectTheme()}
                    style={{
                      color: "white",
                      width: "4rem",
                      height: "4rem",
                      borderRadius: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: currentColor,
                      border: "1px solid black",
                    }}
                  >
                    <Droplet style={{ width: "19px", color: "black" }} />
                  </div>
                  <Label
                    htmlFor="validationCustom4"
                    style={{ fontSize: "15px", paddingLeft: "7px" }}
                  >
                    {"Theme"}
                  </Label>
                  <div
                    style={{
                      display: "flex",
                      position: "absolute",
                      top: "10px",
                      left: "100%",
                    }}
                  >
                    {theme && (
                      <SketchPicker
                        color={currentColor}
                        onChangeComplete={(color) => handleOnChange(color)}
                      />
                    )}
                  </div>
                </div>
                {templateId === qrThemes.theme8 ? (
                  <div
                    style={{
                      padding: "1rem",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      aria-label="add"
                      className="btn
                    "
                      onClick={() => SelectThemeBorder()}
                      style={{
                        color: "white",
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: borderColor,
                        border: "1px solid black",
                      }}
                    >
                      <Droplet style={{ width: "19px", color: "black" }} />
                    </div>
                    <Label
                      htmlFor="validationCustom4"
                      style={{ fontSize: "15px", paddingLeft: "7px" }}
                    >
                      {"Border"}
                    </Label>
                    <div
                      style={{
                        display: "flex",
                        position: "absolute",
                        top: "10px",
                        left: "100%",
                      }}
                    >
                      {border && (
                        <SketchPicker
                          color={borderColor}
                          onChangeComplete={(color) =>
                            handleOnChangeBorder(color)
                          }
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {templateId === qrThemes.theme10 ||
                templateId === qrThemes.theme15 ? (
                  <div
                    style={{
                      padding: "1rem",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      aria-label="add"
                      className="btn
                    "
                      onClick={() => SelectThemeBackground()}
                      style={{
                        color: "white",
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: backgoundTheme,
                        border: "1px solid black",
                      }}
                    >
                      <Droplet style={{ width: "19px", color: "black" }} />
                    </div>
                    <Label
                      htmlFor="validationCustom4"
                      style={{ fontSize: "15px", paddingLeft: "7px" }}
                    >
                      {"Background"}
                    </Label>
                    <div
                      style={{
                        display: "flex",
                        position: "absolute",
                        top: "10px",
                        left: "100%",
                      }}
                    >
                      {backGround && (
                        <SketchPicker
                          color={backgoundTheme}
                          onChangeComplete={(color) =>
                            handleOnChangeBackgound(color)
                          }
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {templateId !== qrThemes.theme10 ? (
                  <div
                    style={{
                      padding: "1rem",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      aria-label="add"
                      className="btn"
                      onClick={() => SelectFontTheme()}
                      style={{
                        color: "white",
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: fontTheme,
                        border: "1px solid black",
                      }}
                    >
                      <Edit3 style={{ width: "19px", color: "black" }} />
                    </div>
                    <Label
                      htmlFor="validationCustom4"
                      style={{ fontSize: "15px", paddingLeft: "16px" }}
                    >
                      {"Title"}
                    </Label>
                    <div
                      style={{
                        display: "flex",
                        position: "absolute",
                        top: "10px",
                        left: "100%",
                      }}
                    >
                      {themeFont && (
                        <SketchPicker
                          color={fontTheme}
                          onChangeComplete={(color) =>
                            handleOnChangeFont(color)
                          }
                        />
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ paddingRight: "1rem" }}>
                  <Tooltip title="Reset to Default">
                    <button
                      type="button"
                      aria-label="reset"
                      className="btn btn-warning"
                      onClick={() => handleResetTheme()}
                      style={{
                        ...Style,
                        color: "#fff",
                        backgroundColor: "#f59e0b",
                        borderColor: "#f59e0b",
                      }}
                    >
                      <RotateCcw size={18} />
                    </button>
                  </Tooltip>
                </div>
                <div style={{ paddingRight: "1rem" }}>
                  <div
                    aria-label="cancel"
                    className="btn btn-danger"
                    // onClick={() => setColor(!color)}
                    onClick={() => close()}
                    style={Style}
                  >
                    <X />
                  </div>
                </div>
                <div style={{ paddingRight: "1rem" }}>
                  <button
                    aria-label="save"
                    className="btn btn-success"
                    style={Style}
                    onClick={(e) => onSubmit(e)}
                    disabled={loaderShow === true}
                  >
                    <Check />
                  </button>
                </div>
              </div>
            </div>
          </ModalHeader>
          {templateId === qrThemes.theme14 && (
            <div
              style={{
                padding: "1.5rem",
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                margin: "1rem 0",
                border: "1px solid #e2e8f0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <div>
                  <h6
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      color: "#1e293b",
                    }}
                  >
                    Background Image
                  </h6>
                  <small style={{ color: "#64748b" }}>
                    Upload a background image for Theme 14
                  </small>
                </div>
                {backgroundImg && (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => setBackgroundImg("")}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "5px",
                      fontSize: "12px",
                      padding: "4px 10px",
                    }}
                  >
                    <Trash2 size={14} /> Remove Image
                  </button>
                )}
              </div>

              <input
                id="theme-bg-file-input"
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp"
                style={{ display: "none" }}
                onChange={handleBackgroundUpload}
              />

              {backgroundImg ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "240px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#ffffff",
                      borderRadius: "6px",
                      border: "1px solid #cbd5e1",
                      padding: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={backgroundImg}
                      alt="Theme Background"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <label
                    htmlFor="theme-bg-file-input"
                    className="btn btn-outline-primary btn-sm"
                    style={{
                      margin: 0,
                      cursor: isUploadingBg ? "wait" : "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {isUploadingBg ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                        <span>Uploading...</span>
                      </>
                    ) : (
                      <>
                        <Upload size={14} />
                        <span>Change Image</span>
                      </>
                    )}
                  </label>
                </div>
              ) : (
                <label
                  htmlFor="theme-bg-file-input"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "2rem",
                    backgroundColor: "#ffffff",
                    border: "2px dashed #cbd5e1",
                    borderRadius: "8px",
                    cursor: isUploadingBg ? "wait" : "pointer",
                    width: "100%",
                    margin: 0,
                    transition: "border-color 0.2s ease",
                  }}
                >
                  {isUploadingBg ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#3b82f6",
                      }}
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                      <span style={{ fontSize: "14px", fontWeight: 500 }}>
                        Uploading background image...
                      </span>
                    </div>
                  ) : (
                    <>
                      <Upload
                        size={32}
                        style={{ color: "#94a3b8", marginBottom: "8px" }}
                      />
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#334155",
                        }}
                      >
                        Click to upload background image
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#94a3b8",
                          marginTop: "4px",
                        }}
                      >
                        PNG, JPG, JPEG, WEBP up to 5MB
                      </span>
                    </>
                  )}
                </label>
              )}
            </div>
          )}
          {templateId === qrThemes.theme15 && (
            <div
              style={{
                padding: "1rem 1.5rem",
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                margin: "1rem 0",
                border: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    color: "#1e293b",
                  }}
                >
                  Card Background Pattern
                </h6>
                <small style={{ color: "#64748b" }}>
                  Enable or disable dotted background pattern on cards
                </small>
              </div>
              <div>
                <Switch
                  value={isTheme15Backstructure}
                  onChange={() =>
                    setIsTheme15Backstructure(!isTheme15Backstructure)
                  }
                  backgroundColor={{ on: "#461F8A", off: "#e5e7eb" }}
                  borderColor={{ on: "#461F8A", off: "#e5e7eb" }}
                />
              </div>
            </div>
          )}
          {templateId === qrThemes.theme1 && (
            <div className="card-wrapper">
              <div className="card-container" style={appStyle.background}>
                <div className="card-dtl text-center">
                  <div className="businessmen-img">
                    <img src={avtar} className="img-fluid" alt="avtar" />
                  </div>
                  <h2 className="businessman-name" style={appStyle.color}>
                    john doe
                  </h2>
                  <h6 className="business-name" style={appStyle.color}>
                    Businesscard Pvt Ltd
                  </h6>
                  <h6 className="business-category" style={appStyle.color}>
                    ( UI UX Designer )
                  </h6>
                </div>
                <div className="card-contact">
                  <div className="contact-items">
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img src={call} className="img-fluid" alt="call" />
                      </div>
                      <p style={appStyle.color}>call</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img
                          src={emailIcon}
                          className="img-fluid"
                          alt="email"
                        />
                      </div>
                      <p style={appStyle.color}>email</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img
                          src={placeholder}
                          className="img-fluid"
                          alt="placeholder"
                        />
                      </div>
                      <p style={appStyle.color}>location</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img src={web} className="img-fluid" alt="web" />
                      </div>
                      <p style={appStyle.color}>website</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img
                          src={whatsapp}
                          className="img-fluid"
                          alt="whatsapp"
                        />
                      </div>
                      <p style={appStyle.color}>whatsapp</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img src={rupee} className="img-fluid" alt="rupee" />
                      </div>
                      <p style={appStyle.color}>pay me</p>
                    </a>
                    <div className="card-item about">
                      <div className="icon-img">
                        <img
                          src={profile}
                          className="img-fluid"
                          alt="profile-user"
                        />
                      </div>
                      <p style={appStyle.color}>about me</p>
                    </div>
                    <div className="card-item gallery">
                      <div className="icon-img">
                        <img
                          src={gallery}
                          className="img-fluid"
                          alt="gallery"
                        />
                      </div>
                      <p style={appStyle.color}>gallery</p>
                    </div>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img src={qrcode} className="img-fluid" alt="qr-code" />
                      </div>
                      <p style={appStyle.color}>QR code</p>
                    </a>
                    <div
                      className="card-item"
                      data-bs-toggle="modal"
                      data-bs-target="#inquiry-form"
                    >
                      <div className="icon-img">
                        <img
                          src={adduser}
                          className="img-fluid"
                          alt="add-user"
                        />
                      </div>
                      <p style={appStyle.color}>save contact</p>
                    </div>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img src={review} className="img-fluid" alt="review" />
                      </div>
                      <p style={appStyle.color}>review</p>
                    </a>
                    <a href="/" className="card-item">
                      <div className="icon-img">
                        <img
                          src={DigitalCard}
                          className="img-fluid"
                          alt="credit-card"
                        />
                      </div>
                      <p style={appStyle.color}>digital card</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
          {templateId === qrThemes.theme14 && (
            <div
              className="card-wrapper my-3"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  borderRadius: "28px",
                  border: "1px solid #232329",
                  boxShadow: "0 30px 60px -20px rgba(0, 0, 0, 0.7)",
                  overflow: "hidden",
                  position: "relative",
                  ...(backgroundImg && backgroundImg.trim() !== ""
                    ? {
                        backgroundImage: `linear-gradient(180deg, rgba(16, 16, 22, 0.68) 0%, rgba(12, 12, 16, 0.78) 45%, rgba(10, 10, 14, 0.90) 100%), url("${backgroundImg}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }
                    : {
                        backgroundColor: "#131318",
                      }),
                }}
              >
                {/* Dotted texture */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "100%",
                    height: "220px",
                    backgroundImage: `radial-gradient(circle, ${currentColor || "#f3cf7c"} 1px, transparent 1.4px)`,
                    backgroundSize: "14px 14px",
                    opacity: 0.35,
                    pointerEvents: "none",
                  }}
                />

                {/* Topbar */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 14px 0",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <svg
                      style={{ width: "24px", height: "24px" }}
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M16 2 L29 24 H3 Z"
                        fill="none"
                        stroke={currentColor || "#f3cf7c"}
                        strokeWidth="2"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 10 L23 22 H9 Z"
                        fill={currentColor || "#f3cf7c"}
                      />
                    </svg>
                    <span
                      style={{
                        color: currentColor || "#f3cf7c",
                        fontSize: "11px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                      }}
                    >
                      {orgName || "Brand"}
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <div
                      style={{
                        border: `1px solid ${currentColor || "#f3cf7c"}`,
                        color: currentColor || "#f3cf7c",
                        backgroundColor: "rgb(19, 19, 24)",
                        borderRadius: "999px",
                        padding: "4px 8px",
                        fontSize: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <span>Save Contact</span>
                    </div>
                  </div>
                </div>

                {/* Profile */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "20px 16px 12px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      width: "96px",
                      height: "96px",
                      borderRadius: "50%",
                      padding: "3px",
                      background: `conic-gradient(from 200deg, ${currentColor || "#f3cf7c"}, ${currentColor || "#f3cf7c"}, ${currentColor || "#f3cf7c"})`,
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={userPhoto || avtar}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "3px solid #131318",
                      }}
                    />
                  </div>
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: 600,
                      color: fontTheme || "#f4f1ea",
                      textAlign: "center",
                      margin: 0,
                    }}
                  >
                    {fname || "John"}{" "}
                    <span style={{ color: currentColor || "#f3cf7c" }}>
                      {lname || "Doe"}
                    </span>
                  </h2>
                  <p
                    style={{
                      fontSize: "12px",
                      color: fontTheme || "#f4f1ea",
                      opacity: 0.85,
                      marginTop: "4px",
                      marginBottom: "2px",
                      textAlign: "center",
                    }}
                  >
                    {designation || "UI / UX Designer"}
                  </p>
                  <p
                    style={{
                      fontSize: "11px",
                      color: currentColor || "#f3cf7c",
                      fontWeight: 500,
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    {orgName || "Businesscard Pvt Ltd"}
                  </p>
                </div>

                {/* Action Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "8px",
                    padding: "4px 14px 16px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {[
                    { img: call, label: "Call" },
                    { img: emailIcon, label: "Email" },
                    { img: placeholder, label: "Location" },
                    { img: web, label: "Website" },
                    { img: whatsapp, label: "WhatsApp" },
                    { img: rupee, label: "Pay Me" },
                    { img: profile, label: "About Me" },
                    { img: gallery, label: "Gallery" },
                    { img: qrcode, label: "QR Code" },
                  ].map((tile, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px 4px",
                        backgroundColor: "#1b1b21",
                        border: `1px solid ${currentColor ? `${currentColor}60` : "rgba(243, 207, 124, 0.4)"}`,
                        borderRadius: "14px",
                        gap: "6px",
                      }}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: `${currentColor ? `${currentColor}15` : "rgba(243, 207, 124, 0.1)"}`,
                          padding: "6px",
                        }}
                      >
                        <img
                          src={tile.img}
                          alt={tile.label}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "10px",
                          color: fontTheme || "#f4f1ea",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        {tile.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* CTA Buttons */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    padding: "0 14px 20px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "12px",
                      fontSize: "11px",
                      fontWeight: 600,
                      border: "none",
                      backgroundColor: currentColor || "#f3cf7c",
                      color: "#1a1305",
                      cursor: "pointer",
                    }}
                  >
                    Share Card
                  </button>
                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "12px",
                      fontSize: "11px",
                      fontWeight: 600,
                      border: `1px solid ${currentColor || "#f3cf7c"}`,
                      color: currentColor || "#f3cf7c",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    Save Contact
                  </button>
                </div>
              </div>
            </div>
          )}
          {templateId === qrThemes.theme15 && (
            <div
              className="card-wrapper my-3"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  borderRadius: "20px",
                  border: "1.5px solid #ffffff",
                  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)",
                  overflow: "hidden",
                  position: "relative",
                  backgroundColor: backgoundTheme || "#d5e2fc",
                }}
              >
                {/* Dotted Texture Background Pattern matching .card-texture in custom.css */}
                {isTheme15Backstructure && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "100%",
                      height: "100%",
                      backgroundImage: `radial-gradient(circle, ${currentColor ? `${currentColor}40` : "rgba(47, 111, 240, 0.25)"} 1.2px, transparent 1.4px)`,
                      backgroundSize: "14px 14px",
                      WebkitMaskImage:
                        "linear-gradient(to bottom, black 0%, black 55%, transparent 100%)",
                      maskImage:
                        "linear-gradient(to bottom, black 0%, black 55%, transparent 100%)",
                      pointerEvents: "none",
                      zIndex: 0,
                    }}
                  />
                )}

                {/* Top Bar with Brand Logo and Action Pills */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "14px 14px 0",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <svg
                      style={{ width: "24px", height: "24px", flexShrink: 0 }}
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        d="M4 24 C10 6, 18 4, 28 20"
                        stroke="#f97316"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                      <path
                        d="M8 24 C14 12, 20 10, 26 22"
                        stroke={currentColor || "#2f6ff0"}
                        strokeWidth="3.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: 700,
                        color: currentColor || "#2f6ff0",
                        fontFamily: "sans-serif",
                        letterSpacing: "-0.3px",
                      }}
                    >
                      Info
                      <span style={{ color: fontTheme || "#171719" }}>
                        soft
                      </span>
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                        padding: "4px 10px",
                        borderRadius: "999px",
                        border: `1.4px solid ${currentColor || "#2f6ff0"}`,
                        color: currentColor || "#2f6ff0",
                        fontSize: "10px",
                        fontWeight: 600,
                        backgroundColor: "#ffffff",
                        cursor: "pointer",
                      }}
                    >
                      <Bookmark size={11} color={currentColor || "#2f6ff0"} />
                      <span>Save Contact</span>
                    </div>
                    <div
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1.4px solid ${currentColor || "#2f6ff0"}`,
                        color: currentColor || "#2f6ff0",
                        backgroundColor: "#ffffff",
                        cursor: "pointer",
                      }}
                    >
                      <Share2 size={11} color={currentColor || "#2f6ff0"} />
                    </div>
                  </div>
                </div>

                {/* Profile Section */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "10px 16px 4px",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <div
                    style={{
                      width: "96px",
                      height: "96px",
                      borderRadius: "50%",
                      padding: "3px",
                      border: `2.5px solid ${currentColor || "#2f6ff0"}`,
                      backgroundColor: "#ffffff",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    <img
                      src={avtar}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <h2
                    style={{
                      fontSize: "19px",
                      fontWeight: 600,
                      color: fontTheme || "#171719",
                      textAlign: "center",
                      margin: 0,
                    }}
                  >
                    Divyesh{" "}
                    <em
                      style={{
                        fontStyle: "normal",
                        color: currentColor || "#2f6ff0",
                      }}
                    >
                      Makavana
                    </em>
                  </h2>
                  <p
                    style={{
                      fontSize: "12px",
                      color: fontTheme || "#171719",
                      opacity: 0.8,
                      marginTop: "3px",
                      marginBottom: "2px",
                      textAlign: "center",
                    }}
                  >
                    Developer
                  </p>
                  <p
                    style={{
                      fontSize: "11.5px",
                      color: currentColor || "#2f6ff0",
                      fontWeight: 500,
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    Demo Compony
                  </p>
                </div>

                {/* Action Grid (6 tiles in 2 rows of 3 columns) */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "10px",
                    padding: "12px 14px 18px",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  {[
                    { img: t15Email, label: "Email" },
                    { img: t15QrCode, label: "QrCode" },
                    { img: t15Location, label: "Location" },
                    { img: t15Inquiry, label: "Inquiry" },
                    { img: t15Download, label: "Download" },
                    { img: t15SaveContact, label: "Save Contact" },
                  ].map((tile, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "12px 6px",
                        backgroundColor: "rgba(255, 255, 255, 0.85)",
                        border: "1.4px solid #ffffff",
                        boxShadow: `0 2px 6px ${currentColor ? `${currentColor}25` : "rgba(47, 111, 240, 0.18)"}`,
                        borderRadius: "14px",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: `${currentColor ? `${currentColor}20` : "rgba(47, 111, 240, 0.12)"}`,
                        }}
                      >
                        <img
                          src={tile.img}
                          alt={tile.label}
                          style={{
                            width: "38px",
                            height: "38px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "10.5px",
                          color: fontTheme || "#171719",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        {tile.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Social Icons Row matching latest backend & design */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    padding: "4px 16px 20px",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  {[
                    { img: t15Facebook, label: "Facebook" },
                    { img: t15Instagram, label: "Instagram" },
                    { img: t15Linkedin, label: "LinkedIn" },
                    { img: t15Pinterest, label: "Pinterest" },
                    { img: t15Indiamart, label: "IndiaMART" },
                  ].map((social, idx) => (
                    <div
                      key={idx}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        border: "2px solid #ffffff",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: `0 2px 4px ${currentColor ? `${currentColor}25` : "rgba(47, 111, 240, 0.18)"}`,
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={social.img}
                        alt={social.label}
                        style={{
                          width: "34px",
                          height: "34px",
                          objectFit: "contain",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* <!-- overlay --> */}
          <div className="overlay"></div>
        </ModalBody>
      </Modal>

      <PreviewPopup
        handlePreview={handlePreview}
        pageId={pageId}
        setStartData={setStartData}
        setEndData={setEndData}
      />
      <MainOrganizationUpdate
        orgUpdateModal={companySlugModal}
        setOrgUpdateModal={setCompanySlugModal}
      />
    </>
  );
};

export default PersonalPageItem;
